import axios from "axios";

api = axios.create({
  headers: {
    Accept: "application/json",
    "Content-type": "application/json",
  },
});

const csrfToken = () => (document.querySelector("meta[name='csrf-token']")?.content || "");

api.interceptors.request.use(
  config => {
    config.headers['X-CSRF-Token'] = csrfToken();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;
